import { CSSProperties, ReactNode } from 'react'

interface CardHeaderProps {
  title?: string
  icon?: any
  HeaderRight?: ReactNode
  style?: CSSProperties
}

export const CardHeader = (props: CardHeaderProps) => {
  const { title, icon, HeaderRight, style } = props

  return (
    <div
      style={{
        padding: 16,
        fontSize: 16,
        fontWeight: 600,
        textTransform: 'uppercase',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...style
      }}
    >
      <div>
        {icon} {title}
      </div>
      <div>{HeaderRight}</div>
    </div>
  )
}
